import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'home',
    path: '/',
    component: () => import('../pages/HomePage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'videoHelp',
    path: '/videos',
    component: () => import('../pages/VideosHtmlContent.vue')
  },
  {
    name: 'helpDoc',
    path: '/help',
    component: () => import('../pages/HelpDocument.vue')
  },
  {
    name: 'tocDoc',
    path: '/toc',
    component: () => import('../pages/TocDocument.vue')
  }
];

export default routes;
